var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKiroLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#E33939"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.859,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73736 7.18408C9.06729 7.18408 9.39722 7.18408 9.72716 7.18408C9.75471 11.282 9.72716 15.3795 9.64467 19.4769C9.36967 20.009 9.09479 20.5412 8.81984 21.0733C8.73736 16.4439 8.70987 11.8141 8.73736 7.18408Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2188 7.18398C10.5969 7.14311 10.9544 7.19627 11.2911 7.34362C11.4011 10.4834 11.4011 13.623 11.2911 16.7628C10.9203 17.2142 10.5903 17.6932 10.3013 18.1996C10.2188 14.528 10.1913 10.8562 10.2188 7.18398Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.727,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7169 7.18398C12.095 7.14311 12.4525 7.19627 12.7892 7.34362C12.8992 9.57867 12.8992 11.8137 12.7892 14.0488C12.4183 14.5003 12.0884 14.9792 11.7994 15.4856C11.7169 12.7189 11.6893 9.95177 11.7169 7.18398Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.752,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1516 7.1848C17.5228 7.13387 17.8527 7.21369 18.1414 7.42427C15.3015 12.3617 12.5246 17.3374 9.81057 22.3512C9.47387 22.4986 9.11647 22.5517 8.73828 22.5109C11.3693 17.3121 14.1738 12.2034 17.1516 7.1848Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.761,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4568 7.18416C18.8813 7.12797 19.2662 7.20779 19.6116 7.42363C16.7717 12.361 13.9948 17.3367 11.2808 22.3506C10.9279 22.5532 10.5706 22.5532 10.2085 22.3506C13.0042 17.3118 15.7537 12.2563 18.4568 7.18416Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1185 7.18416C20.5429 7.12797 20.9278 7.20779 21.2732 7.42363C18.4333 12.361 15.6564 17.3367 12.9424 22.3506C12.6057 22.4979 12.2482 22.5511 11.8701 22.5102C11.9122 22.1085 12.0498 21.7359 12.2825 21.3927C14.9806 16.7029 17.5925 11.9667 20.1185 7.18416Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.722,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3085 15.4858C18.6655 17.7385 19.9852 20.0267 21.2677 22.3506C20.8497 22.5545 20.4372 22.5545 20.0304 22.3506C18.9857 20.4349 17.9408 18.5191 16.8961 16.6034C16.8438 16.1712 16.9812 15.7987 17.3085 15.4858Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.734,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4937 16.9229C16.7221 17.0943 16.9145 17.3071 17.071 17.5614C17.9566 19.1381 18.809 20.7346 19.628 22.3508C19.3111 22.533 18.9812 22.5596 18.6382 22.4307C17.82 21.0333 17.0225 19.623 16.2462 18.2C16.1278 17.7359 16.2103 17.3102 16.4937 16.9229Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.714,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.677 18.3594C15.9959 18.5417 16.2433 18.8077 16.4194 19.1576C16.9547 20.247 17.5321 21.3114 18.1515 22.3505C17.7666 22.5633 17.3816 22.5633 16.9967 22.3505C16.5164 21.3674 15.9939 20.4096 15.4296 19.4769C15.3291 19.0674 15.4116 18.6948 15.677 18.3594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiroLogoRed);
export default __webpack_public_path__ + "static/media/kiro-Logo-Red.db8b0f3d2fdbaadf4a004e4447236a30.svg";
export { ForwardRef as ReactComponent };